// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AuthNav_wrapper__2Gp0o","link":"AuthNav_link__bsqLh","active":"AuthNav_active__1Y0YO"};